import React, { useState, useEffect, useRef } from "react";
import {
  I2cButton,
  I2cIcon,
  I2cAvatar,
  I2cPagination,
  I2cInput,
  I2cBadge,
  I2cDrawer,
  I2cActivityFeeds,
  I2cDivider,
  I2cFormatDate,
} from "@webcomponents/i2cwebcomponents/dist/react";
import projectsStack from "../../assets/images/projects-stack.svg";
import projectsStackWhite from "../../assets/images/projects-stack-white.svg";
import "../../Utils/shared-styles/Authentication.scss";
import "./Users.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import _ from "lodash";
import AlertMessage from "../../Components/SharedComponent/Alert/Alert";
import UserManagmentService from "../../Services/UsermanagmentService";
import ConfirmaionModal from "../../Components/ConfirmationModal/ConfirmationModal";
import {
  formatPhoneNumber,
  getFormatedDate,
  phoneNumberFormat,
} from "../../Utils/stringUtls";
import { useMutation, useQuery } from "react-query";
import { OverlayLoader } from "../../Components/Loader/Loader";
import { FiltersDrawerContent } from "./FiltersDrawerContent";

/**
 * Users Component displays a list of users with user management features.
 *
 * @component
 */
const Users = () => {
  // Hooks for navigation and query parameters
  const drawerRef = useRef();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const isUserAdded = searchParams.get("user-added") ?? false;
  const isUserUpdated = searchParams.get("user-updated") ?? false;

  // State variables
  const [showConfirmatonModal, setShowConfirmatonModal] = useState(false);
  const [page, setPage] = useState(1);
  const [usersType, setUsersType] = useState("internal");
  const [searchKey, setSearchkey] = useState("");
  const [deleteableUser, setDeleteableUser] = useState();
  const [showAlert, setShowAlert] = useState(null);
  const [debouncedSearchKey, setDebouncedSearchKey] = React.useState("");

  const [total, setTotal] = useState(false);
  const perPage = 4;
  const [users, setUsers] = useState([]);
  const [openSupport, setSupportOpen] = useState(false);
  const [filterData, setFilterData] = useState({
    role: "",
    from: "",
    to: "",
  });

  const toggleDrawer = () => {
    setSupportOpen(!openSupport);
  };
  const {
    data,
    error,
    isLoading,
    isFetching,
    refetch: refetchUsers,
  } = useQuery(
    ["getUsers", page, usersType, filterData, debouncedSearchKey],
    () =>
      UserManagmentService.getUsers(
        page,
        usersType,
        filterData,
        debouncedSearchKey,
      ),
    {
      refetchOnWindowFocus: false,
    },
  );
  const {
    data: userProfileData,
    error: userProfileError,
    isLoading: userProfileIsLoading,
    isFetching: userProfileIsFetching,
    refetch: refetchUserProfile,
  } = useQuery("userProfile", () => UserManagmentService.getUserProfile(), {
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data) {
      setUsers(data?.data?.data?.data);
      setTotal(data?.data?.data?.total);
    }
  }, [data]);
  /**
   * Handle button click to navigate to the current location without query parameters.
   */
  const handleButtonClick = () => {
    navigate(".", { replace: true });
  };

  // const [debouncedLoading, setDebouncedLoading] =
  //   React.useState<boolean>(false);

  // Debounce the value change
  React.useEffect(() => {
    const debounceSearch = _.debounce((value) => {
      setDebouncedSearchKey(value);
      // setDebouncedLoading(false);
    }, 1000); // Adjust the debounce delay as needed (e.g., 300ms)

    debounceSearch(searchKey);

    return () => {
      debounceSearch.cancel(); // Cancel the debounce function on component unmount
    };
  }, [searchKey]);
  useEffect(() => {
    if (isUserAdded || isUserUpdated) {
      setTimeout(() => {
        searchParams.delete("user-added");
        searchParams.delete("user-updated");
        setSearchParams(searchParams);
      }, 5000);
    }
  }, [isUserAdded, isUserUpdated]);

  const userDeleteMutation = useMutation(
    (userId) => UserManagmentService.deleteUser(userId),
    {
      onSuccess: () => {
        // Optional: Perform any actions after successful deletion
        refetchUsers();
        setShowConfirmatonModal(false);
        setShowAlert({
          open: true,
          success: true,
          message: "Record has been deleted successfully!",
        });
      },
      onError: (e) => {
        setShowConfirmatonModal(false);
        setShowAlert({
          open: true,
          success: false,
          message: "Something went wrong",
        });
      },
    },
  );

  const handleUserDelete = () => {
    userDeleteMutation.mutate(deleteableUser.id);
  };
  function handleSupportRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    } else setSupportOpen(false);
  }
  const handleClearAll = () => {
    setSupportOpen(false);
    setFilterData({
      role: "",
      from: "",
      to: "",
    });
  };

  // if (isLoading || isFetching) return <OverlayLoader />;
  return (
    <React.Fragment>
      <I2cDrawer
        label="Filters"
        className="sales-filter-drawer"
        sub-label=""
        open={openSupport}
        onClose={() => setSupportOpen(false)}
        onI2cRequestClose={handleSupportRequestClose}
        ref={drawerRef}
      >
        <I2cActivityFeeds variant="" type="notification">
          <FiltersDrawerContent
            onClose={() => {
              setSupportOpen(false);
              setFilterData({
                role: "",
                from: "",
                to: "",
              });
            }}
            defaultValues={filterData}
            handleConfirmation={(filterData) => {
              if (filterData.role === "client") setUsersType("external");
              else setUsersType("internal");
              setSupportOpen(false);
              setFilterData(filterData);
            }}
          />
        </I2cActivityFeeds>
      </I2cDrawer>
      {/* Users Listing Layout */}
      <div className="layout_aside_logged_user users-listing">
        {/* Users Listing Header */}
        <div className="users-listing-header">
          <div className="users-listing-title">
            <h1>User Management</h1>
          </div>

          <div className="users-listing-header-actions-web">
            {/* Search and Add Buttons */}

            <I2cButton variant="secondary gray" onClick={toggleDrawer}>
              <I2cIcon name="linear-setting-4" />
            </I2cButton>
            <I2cButton
              onClick={() => {
                navigate("/users/add");
              }}
            >
              Add New
            </I2cButton>

            <div className="search-bar-action">
              <I2cInput
                className={`search-input`}
                onI2cInput={(e) => setSearchkey(e.target.value)}
                style={{
                  width: "calc(var(--i2c-spacing-64) - var(--i2c-spacing-1-5))",
                }}
                value={searchKey}
                placeholder="Search"
                size="medium"
              >
                <I2cIcon slot="prefix" name="cs-linear-search" />
              </I2cInput>
            </div>
          </div>
          <div className="users-listing-header-actions-mobile">
            <div className="row-1">
              <I2cButton
                onClick={toggleDrawer}
                className="filter-mobile-button"
                variant="secondary gray"
              >
                <I2cIcon name="linear-setting-4" />
              </I2cButton>
              <I2cButton
                onClick={() => {
                  navigate("/users/add");
                }}
                className="add-new-mobile-button"
              >
                Add New
              </I2cButton>
            </div>
            <I2cInput
              size="large"
              onI2cInput={(e) => setSearchkey(e.target.value)}
              placeholder="Search"
              className={`search-input`}
            >
              <I2cIcon
                slot="prefix"
                name="cs-linear-search"
                color="black"
                variant="default"
              />
            </I2cInput>
          </div>
        </div>

        {/* Users Listing Tabs */}
        <div className="users-listing-tabs">
          {filterData.role !== "" ? (
            <>
              {filterData.role !== "client" && (
                <>
                  <I2cButton
                    onClick={() => {
                      setUsersType("internal");
                    }}
                    size="small"
                    variant={
                      usersType === "internal"
                        ? "secondary color"
                        : "tertiary black"
                    }
                    className={`users-listing-tab ${
                      usersType === "internal" ? "active-tab" : ""
                    }`}
                  >
                    Internal
                  </I2cButton>

                  <I2cButton
                    onClick={() => {
                      setPage(1);
                      setUsersType("external");
                    }}
                    size="small"
                    variant={
                      usersType === "external"
                        ? "secondary color"
                        : "tertiary black"
                    }
                    className={`users-listing-tab ${
                      usersType === "external" ? "active-tab" : ""
                    }`}
                    disabled={true}
                  >
                    External
                  </I2cButton>
                </>
              )}

              {filterData.role === "client" && (
                <>
                  <I2cButton
                    onClick={() => {
                      setUsersType("internal");
                    }}
                    size="small"
                    variant={
                      usersType === "internal"
                        ? "secondary color"
                        : "tertiary black"
                    }
                    className={`users-listing-tab ${
                      usersType === "internal" ? "active-tab" : ""
                    }`}
                    disabled={true}
                  >
                    Internal
                  </I2cButton>

                  <I2cButton
                    onClick={() => {
                      setPage(1);
                      setUsersType("external");
                    }}
                    size="small"
                    variant={
                      usersType === "external"
                        ? "secondary color"
                        : "tertiary black"
                    }
                    className={`users-listing-tab ${
                      usersType === "external" ? "active-tab" : ""
                    }`}
                  >
                    External
                  </I2cButton>
                </>
              )}
            </>
          ) : (
            <>
              <I2cButton
                onClick={() => {
                  setUsersType("internal");
                }}
                size="small"
                variant={
                  usersType === "internal"
                    ? "secondary color"
                    : "secondary gray"
                }
                className={`users-listing-tab ${
                  usersType === "internal" ? "active-tab" : ""
                }`}
              >
                Internal
              </I2cButton>

              <I2cButton
                onClick={() => {
                  setPage(1);
                  setUsersType("external");
                }}
                size="small"
                variant={
                  usersType === "external"
                    ? "secondary color"
                    : "secondary gray"
                }
                className={`users-listing-tab ${
                  usersType === "external" ? "active-tab" : ""
                }`}
              >
                External
              </I2cButton>
            </>
          )}
        </div>
        {(filterData.role !== "" ||
          filterData.from !== "" ||
          filterData.to !== "") && (
          <div
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-2)",
              flexWrap: "wrap",
              alignItems: "center",
              marginTop: "var(--i2c-spacing-6)",
            }}
          >
            {filterData.role !== "" && (
              <I2cBadge
                className="pointer"
                variant="light-primary" outline
                size="small"
                onClick={() => {
                  setFilterData({
                    role: "",
                    from: filterData.from,
                    to: filterData.to,
                  });
                }}
              >
                {filterData.role}
                <I2cIcon slot="suffix" name="cs-linear-close"></I2cIcon>
              </I2cBadge>
            )}

            {(filterData.from !== "" || filterData.to !== "") && (
              <I2cBadge
                className="pointer"
                variant="light-primary" outline
                size="small"
                onClick={() => {
                  setFilterData({
                    role: filterData.role,
                    from: "",
                    to: "",
                  });
                }}
              >
                {new Date(filterData.from).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
                {filterData.to &&
                  new Date(filterData.to).toString() !== "Invalid Date" && (
                    <span>
                      &nbsp;-{" "}
                      {new Date(filterData.to).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </span>
                  )}
                <I2cIcon slot="suffix" name="cs-linear-close"></I2cIcon>
              </I2cBadge>
            )}

            <I2cButton
              variant="link color"
              size="xx-small"
              onClick={handleClearAll}
            >
              <I2cIcon slot="prefix" name="cs-linear-close"></I2cIcon>
              Clear All
            </I2cButton>
          </div>
        )}

        {/* User Added and Updated Alerts */}
        {isUserAdded && (
          <div
            onClick={handleButtonClick}
            className="user-added-success-message"
          >
            <AlertMessage
              variant="success"
              message={"User has been added successfully"}
              headerArt="linear-tick-circle"
              open={isUserAdded}
              duration={5000}
              closeAble={true}
            />
          </div>
        )}
        {isUserUpdated && (
          <div
            onClick={handleButtonClick}
            className="user-added-success-message"
          >
            <AlertMessage
              variant="success"
              message={"User updated successfully"}
              headerArt="linear-tick-circle"
              open={isUserUpdated}
              duration={5000}
              closeAble={true}
            />
          </div>
        )}
        {showAlert?.open && (
          <div
            onClick={() => setShowAlert(null)}
            className="user-added-success-message"
          >
            <AlertMessage
              variant={showAlert?.success ? "success" : "danger"}
              message={showAlert?.message}
              headerArt={
                showAlert?.success
                  ? "linear-tick-circle"
                  : "cs-linear-alert-circle"
              }
              open={showAlert?.open}
              closeAble={true}
            />
          </div>
        )}

        {/* User Listing Section */}
        {users?.length ? (
          <div className="users-listing-section">
            {(isLoading || isFetching) && <OverlayLoader />}
            {users.map((user, index) => {
              const formattedDateTime = getFormatedDate(user.created_at);
              const userId = user.user_id;
              const userRolestr = user.role_name;
              const strUserName = userRolestr.replace(/_/g, " ");
              const superAdmin =
                userProfileData?.data?.data?.user?.role_name === "super_admin";
              return (
                <div
                  key={user.user_id + index}
                  className="users-listing-section-single-user"
                >
                  <div className="single-user-parent">
                    <div className="single-user-inner1">
                      {/* User Avatar and Details */}
                      <div className="single-user-inner1-child1">
                        <I2cAvatar
                          initials={user.name.split(' ')
                          .map(word => word[0])
                          .join('')
                          .substring(0, 2)
                          .toUpperCase()}
                          label="Avatar with initials: i2c"
                          size="xLarge"
                          className="single-user-avatar"
                          image={`data:image/jpeg;base64,${user.avatar}`}
                        />

                        <div className="single-user-detail">
                          {/* User Name and Department */}
                          <div className="single-user-name">
                            <div>{user.name}</div>
                            <div className="single-user-dept-badge">
                              <I2cBadge variant="light-primary" size="small">
                                {" "}
                                {user.role ?? "Sales"}
                              </I2cBadge>
                            </div>
                            {/* <div className="single-user-dept">
                              {user.role ?? "Sales"}
                            </div> */}
                          </div>
                          {/* User Creation Date */}
                          <div className="single-user-date">
                            <I2cFormatDate
                              month="short"
                              day="numeric"
                              year="numeric"
                              date={formattedDateTime.date}
                            />{" "}
                            - {formattedDateTime.time}
                          </div>
                        </div>
                      </div>

                      {/* User Projects and Actions */}
                      <div className="single-user-inner1-child2">
                        {/* Projects Button */}
                        <I2cButton
                          variant="secondary gray"
                          className="child2-projects"
                          size="x-small"
                          onClick={() => {
                            navigate(`/forms/users/${user.user_id}`);
                          }}
                        >
                          <span>
                            <I2cIcon
                              className="projects-icon"
                              name="cs-linear-layers-two"
                            />
                          </span>
                          <span className="projects-count">
                            {user.project_count} Projects
                          </span>
                        </I2cButton>

                        {/* Edit User Button */}
                        <I2cButton
                          onClick={() => {
                            navigate(`/users/${user.user_id}`);
                          }}
                          variant="secondary gray"
                          size="x-small"
                        >
                          <I2cIcon name="linear-edit-2" />
                        </I2cButton>

                        {/* Delete User Confirmation Modal */}
                        {superAdmin && (
                          <div className="login__remember">
                            <ConfirmaionModal
                              key={user.user_id}
                              open={showConfirmatonModal}
                              setOpen={() => setShowConfirmatonModal(false)}
                              title={"Delete Record"}
                              headerArt={"cs-linear-alert-circle"}
                              message={
                                "Are you sure you want to delete the user?"
                              }
                              variant="danger"
                              layout={"layoutCenter"}
                              cancelButtonText={"Cancel"}
                              confirmButtonText={"Delete"}
                              confirmBtnVariant={"primary"}
                              destructive={true}
                              handleConfirmation={handleUserDelete}
                              disableConfirmBtn={userDeleteMutation.isLoading}
                              disableCancelBtn={userDeleteMutation.isLoading}
                            >
                              {/* Delete User Button */}
                              <I2cButton
                                onClick={() => {
                                  setDeleteableUser(user);
                                  setShowConfirmatonModal(true);
                                }}
                                variant="secondary gray"
                                className=""
                                size="x-small"
                              >
                                <I2cIcon
                                  name="linear-trash"
                                  color="black"
                                  variant="default"
                                />
                              </I2cButton>
                            </ConfirmaionModal>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* User Details */}
                    <div className="single-user-inner2">
                      {/* Designation */}
                      <div className="single-user-inner2-child">
                        <div className="child-header">Designation</div>
                        <div className="child-value">
                          {user.designation ?? "-"}
                        </div>
                      </div>

                      {/* Email Address */}
                      <div className="single-user-inner2-child">
                        <div className="child-header">Email Address</div>
                        <div className="child-value">{user.email ?? "-"}</div>
                      </div>

                      {/* Contact */}
                      <div className="single-user-inner2-child">
                        <div className="child-header">Contact</div>
                        <div className="child-value">
                          {/* {formatPhoneNumber(
                            user.contact ?? "-",
                            user.contact_country,
                          )} */}
                          {phoneNumberFormat(user.contact ?? "")}
                        </div>
                      </div>
                    </div>
                    <div className="single-user-inner1-child2-mobile">
                      {/* Projects Button */}
                      <I2cButton
                        style={{
                          width: "100%",
                          marginTop: "var(--i2c-spacing-2)",
                        }}
                        variant="primary"
                        className="child2-projects"
                        onClick={() => {
                          navigate(`/forms/users/${user.user_id}`);
                        }}
                      >
                        <span slot="prefix">
                          <img
                            className="projects-icon"
                            src={projectsStackWhite}
                          />
                        </span>
                        <span>{user.project_count} Projects</span>
                      </I2cButton>

                      {/* Edit User Button */}
                      <I2cButton
                        onClick={() => {
                          navigate(`/users/${user.user_id}`);
                        }}
                        className="edit-profile-icon"
                        variant="secondary gray"
                      >
                        <I2cIcon
                          slot="prefix"
                          name="linear-edit-2"
                          variant="default"
                        />
                        Edit Profile
                      </I2cButton>
                      {superAdmin && (
                        <div className="login__remember">
                          <ConfirmaionModal
                            key={user.user_id}
                            open={showConfirmatonModal}
                            setOpen={() => setShowConfirmatonModal(false)}
                            title={"Delete Record"}
                            headerArt={"cs-linear-alert-circle"}
                            message={
                              "Are you sure you want to delete the user?"
                            }
                            variant="danger"
                            layout={"layoutCenter"}
                            cancelButtonText={"Cancel"}
                            confirmButtonText={"Delete"}
                            confirmBtnVariant={"primary"}
                            destructive={true}
                            handleConfirmation={handleUserDelete}
                            disableConfirmBtn={userDeleteMutation.isLoading}
                            disableCancelBtn={userDeleteMutation.isLoading}
                          >
                            {/* Delete User Button */}
                            <I2cButton
                              onClick={() => {
                                setDeleteableUser(user);
                                setShowConfirmatonModal(true);
                              }}
                              style={{
                                width: "100%",
                                marginTop: "var(--i2c-spacing-2)",
                              }}
                              variant="secondary gray"
                              className="delete-user-button child2-projects"
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                slot="prefix"
                              >
                                <I2cIcon name="linear-trash" />
                              </span>
                              <span>Delete</span>
                            </I2cButton>
                          </ConfirmaionModal>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            <div>
              <I2cPagination
                className="users-list-pagination"
                quickButtonsAsLink
                totalCount={total}
                pageSize={perPage}
                currentPage={page}
                setPage={setPage}
              ></I2cPagination>
            </div>
          </div>
        ) : !isLoading && !isFetching && !data?.data?.data?.data?.length ? (
          <div i2c-grid="6@md offset-4@md" className="no-user-container">
            <I2cIcon
              className="cs-icon-shadowed"
              variant="shadowed"
              name="linear-info-circle"
            />
            <div className="no-user-title">No User Found</div>
            <div className="no-user-text">
              It seems like there are currently no clients matching your search
              criteria or available in the system.
            </div>
          </div>
        ) : (
          <OverlayLoader />
        )}

        {/* User Pagination */}
      </div>
    </React.Fragment>
  );
};

export default Users;
